// extracted by mini-css-extract-plugin
export default {"authorTemplate":"template-one-module__authorTemplate__ykO+j"};